
import React from "react";

interface GeneratorActionsProps {
  onGenerateIdeas: () => void;
  onReset: () => void;
  themeClasses: {
    buttonClass: string;
  };
}

const GeneratorActions: React.FC<GeneratorActionsProps> = ({
  onGenerateIdeas,
  onReset,
  themeClasses
}) => {
  return (
    <div className="flex flex-wrap gap-2">
      <button
        onClick={onGenerateIdeas}
        className={`${themeClasses.buttonClass} flex-1`}
      >
        Find Holiday Recipes
      </button>
      <button
        onClick={onReset}
        className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-2 px-4 rounded transition-colors"
      >
        Reset Filters
      </button>
    </div>
  );
};

export default GeneratorActions;
